import React from "react";
import Button from "@material-ui/core/Button";
import {useMutation} from "@apollo/client";
import {loader} from "graphql.macro";
import {useSnackbar} from "notistack";
import {errorMessage, successMessage} from "../../utils/messages";


const REJECT_EXCHANGE_MUTATION = loader('../../gql/mutations/rejectExchange.graphql');

export default function RejectButton({shipmentCode}) {
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    const [sendAckExchange] = useMutation(REJECT_EXCHANGE_MUTATION, {
        onError: error => errorMessage('Chyba pri odosielaní: ' + error, enqueueSnackbar, closeSnackbar),
        onCompleted: () => successMessage('Prekladanie odmietnuté.', enqueueSnackbar, closeSnackbar),
        refetchQueries: () => ['shipmentList'],
    });

    return (
        <Button
            variant="contained"
            onClick={() => sendAckExchange({
                variables: {
                    shipmentId: shipmentCode,
                },
            })}
        >
            Odmietnuť
        </Button>
    );
};
